import { render, staticRenderFns } from "./ProjectsFinished.vue?vue&type=template&id=215957e8&scoped=true&"
import script from "./ProjectsFinished.vue?vue&type=script&lang=js&"
export * from "./ProjectsFinished.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsFinished.vue?vue&type=style&index=0&id=215957e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215957e8",
  null
  
)

export default component.exports